<!-- Date Range Picker (hidden form field required for the date range picker to work properly) -->
<mat-form-field appearance="outline" style="display: none;">
  <mat-date-range-input [formGroup]="dateRange" [rangePicker]="dateRangePicker" [dateFilter]="futureDayFilter">
    <input matStartDate formControlName="start">
    <input matEndDate formControlName="end">
  </mat-date-range-input>
</mat-form-field>

<!-- Date Range Picker (Calendar) -->
<mat-date-range-picker
  touchUi
  [dateClass]="dateClass"
  #dateRangePicker>
</mat-date-range-picker>

<!-- Date Range Control Buttons -->
<div class="date-range-btns-container">
  <!-- Go Back a Week Button -->
  <button
    (click)="goBackAWeek()" 
    class="date-range-picker-btn" 
    matTooltip="Go back a week" 
    matTooltipPosition="above">
    <app-icon name="arrow_left" color="black"></app-icon>
  </button>

  <!-- Set to Current Week Button -->
  <button 
    (click)="initializeCurrentWeekRange()" 
    class="date-range-picker-btn" 
    matTooltip="Set dates to current week" 
    matTooltipPosition="above">
    <span>This Week</span>
  </button>

  <!-- Go Forward a Week Button -->
  <button 
    (click)="goForwardAWeek()" 
    class="date-range-picker-btn" 
    matTooltip="Go forward a week" 
    matTooltipPosition="above">
    <app-icon name="arrow_right" color="black"></app-icon>
  </button>

  <!-- Date Range Picker Calendar Toggle -->
  <button 
    (click)="dateRangePicker.open()" 
    class="date-range-picker-btn"
    matTooltip="Open Date Range Picker"
    matTooltipPosition="above">
    <app-icon name="calendar" color="black"></app-icon>
    <span>{{ dateRange.value.start | date: 'dd. MMMM yyyy' }} - {{ dateRange.value.end | date: 'dd. MMMM yyyy' }}</span>
  </button>
</div>
